import template from './rw-box.html';

export default {
  transclude: true,
  template,
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-box/rw-box-component.js